export const HospitalStatus = [
  { value: 'currently_hospitalised', text: 'Currently hospitalised' },
  { value: 'hospitalised_in_6months', text: 'Will be hospitalised within 6 months' },
  { value: 'discharged_from_hospital', text: 'Discharged from hospital' },
  { value: 'does_not_require_hospitalisation', text: 'Does not require hospitalisation' }
];